module.exports = __webpack_public_path__ + "img/Map_2__First_Canal.f89258d3.jpg";